export default "__VITE_ASSET__BeLfhIkj__"